import { render, staticRenderFns } from "./StepperCard.vue?vue&type=template&id=4c97a512&scoped=true&lang=html&"
import script from "./StepperCard.vue?vue&type=script&lang=js&"
export * from "./StepperCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c97a512",
  null
  
)

export default component.exports